import React, { Component, Fragment, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom"
import logo from '../../logo.svg'
import './style.css';
import { useSelector, useDispatch } from 'react-redux';
// import { loginUser, authSelector, clearState } from './homeSlice';
import { googleSignInAsyn, googleSignInErrorAsyn, authSelector, clearState } from '../Auth/authSlice';
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { LoadingOutlined, SyncOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Layout, Form, Input, Button, Checkbox, Row, Col, Radio, Space, Spin, Image } from 'antd';
const { Header, Footer, Sider, Content } = Layout;
const { ReactDraggable: Draggable, ReactDOM } = window;


const layout = {
  wrapperCol: { span: 24, offset: 0 }
};


const tailLayout = {
  wrapperCol: { span: 24, offset: 0 }
};


const tailForgotLayout = {
  wrapperCol: { xs: { span: 24 }, sm: { span: 24, offset: 0 }, md: { span: 24, offset: 0 }, lg: { span: 24, offset: 0 } }
};

const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

const Home = () => {
  const [value, setValue] = React.useState('admin');
  const dispatch = useDispatch();
  let history = useHistory()

  const [form] = Form.useForm();
  const [requiredMark, setRequiredMarkType] = useState('optional');

  const onRequiredTypeChange = ({ requiredMarkValue }) => {
    setRequiredMarkType(requiredMarkValue);
  };

  const [isLoading, setLoading] = React.useState(false);

  const { isFetching, isGoogleSignIn, isError, errorMessage, googleResponse } = useSelector(
    authSelector
  );

  const setLoadingFn = (val) => {
    setLoading(val);
  }

  useEffect(() => {
    return () => {
      // dispatch(clearState());
    };
  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);

      toast.error(errorMessage);

    }
    if (isGoogleSignIn) {
      dispatch(clearState());
      setLoading(false);
      toast.success('Authentificated successfully');
      history.push('/login');

    }
  }, [isError, isGoogleSignIn, setLoading]);

  const onChange = e => {
    // console.log('radio checked', e.target.value);
    setValue(e.target.value);
  };


  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };

  const responseGoogle = (response) => {
    // console.log(response);
    setLoading(true);
    dispatch(googleSignInAsyn(response));
  }


  const responseGoogleFail = (response) => {
    // console.log(response);
    setLoading(true);
    dispatch(googleSignInErrorAsyn(response));
  }

  const googleLogout = () => {
    // console.log('logout')
  }

  return (
    <Layout className="layout">
      <Content className="content">
        <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
        {/* <Toaster
  position="top-center"
  reverseOrder={false}
/> */}

        <Toaster
          toastOptions={{
            className: '',
            style: {
              border: '1px solid #713200',
              padding: '16px',
              color: '#713200',
              marginTop: 50
            },
          }}
        >
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {icon}
                  {message}
                  {t.type !== 'loading' && (
                    <button onClick={() => toast.dismiss(t.id)}>X</button>
                  )}
                </>
              )}
            </ToastBar>
          )}
        </Toaster>


        <Row style={{ width: '100%', height: '100%' }}>
          <Col span={9} >
            <div style={{ background: `url('./images/login-bg.png') center center /cover`, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Image
                style={{ zIndex: 1 }}
                preview={false}
                // width={50}
                // height={50}
                // src="./images/logo.png"
                src="./images/naf-logo.png"
              />
            </div>
            {/* <Image
    style={{zIndex:-1}}
    preview={false}
      width={'100%'}
      height={'100%'}
      src="./images/login-bg.png"
    >
       <Image
        style={{zIndex:1}}
        preview={false}
        width={50}
        height={50}
        src="./images/logo.png"
        />
      </Image> */}

          </Col>
          <Col span={15} style={{ paddingBottom: 100, height: '100vh' }}>
            <Row className="form-row">
              <Col md={{ span: 14, offset: 6 }} sm={{ span: 12, offset: 6 }} xs={{ span: 12, offset: 6 }}>
                <h1 style={{ marginBottom: 0, fontSize: 28, fontWeight: 300 }}>Welcome to</h1>
                <h1 className="form-row-h1">Process Automation System</h1>

                <Row style={{ width: '100%' }}>
                  <Col span="24" className="googlecol">
                    <GoogleLogin
                      //clientId="675374412936-qtnji6rp6vbbppn22t29qhci9hhgrt5n.apps.googleusercontent.com"
                      clientId="6287006899-k6v4o0puqbigtuosclon5b32o4h91u3v.apps.googleusercontent.com"
                      buttonText={<p >Login with Google</p>}
                      onSuccess={responseGoogle}
                      onFailure={responseGoogleFail}
                      cookiePolicy={'single_host_origin'}
                    />

                    {/* <GoogleLogout buttonText="Logout" onLogoutSuccess={googleLogout} /> */}
                  </Col>
                </Row>

              </Col>
            </Row>


          </Col>
        </Row>

      </Content>
      {/* <Footer>Footer</Footer> */}
    </Layout>

  );
};

export default Home;